import type { IANATimezones } from '@gcv/shared';

import { DateTimeHelpers } from 'util/dateTime.util';
import type { RatingHistoryRow } from './build-rating-history-rows';

export const formatRatingHistorySummary = (rows: RatingHistoryRow[], timezone?: IANATimezones): string => {
  if (!rows.length) {
    return 'No rating changes';
  }

  const changes = `${rows.length} rating change${rows.length === 1 ? '' : 's'}`;

  return `${changes} · last ${DateTimeHelpers.formatISOToFriendlyDateString(rows[0].date, timezone)}`;
};
